import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { Grid, Button, Typography, Box } from "@mui/material";
import { USERS_API } from "../api";
import { addNewMessage } from "../slice";
import Input from "../components/Input";
import { ReactComponent as Logo1 } from "../assets/images/Logo_1.svg";
import Footer from "./Footer";

function NewPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { mutate: resetPassword } = useMutation((body) => USERS_API.ResetPassword(body), {
    onError: ({
      response: {
        data: { message },
      },
    }) => {
      dispatch(
        addNewMessage({
          id: "resetPassword",
          text: message,
          type: "error",
        })
      );
    },
    onSuccess: () => {
      //todo: in qsmt hm shyd niaz bashe payam neshon bdim
      window.sessionStorage.removeItem("action-type");
      window.sessionStorage.removeItem("phoneNumber");
      window.sessionStorage.removeItem("email");
      window.sessionStorage.removeItem("otp_value");
      navigate("/sign-in");
    },
  });

  const handleSubmitForm = (event) => {
    event.preventDefault();
    let email = window.sessionStorage.getItem("email");
    let phoneNumber = window.sessionStorage.getItem("phoneNumber");
    let body = {
      password: event.target.password.value,
      confirmPassword: event.target.confirmPassword.value,
      email: email === null ? "" : email,
      phoneNumber: phoneNumber === null ? "" : phoneNumber,
      token: window.sessionStorage.getItem("otp_value"),
    };
    //todo: in qsmt byd body validate shavad
    resetPassword(body);
  };

  return (
    <Grid
      container
      maxWidth="1920px"
      width="100%"
      minHeight="100vh"
      bgcolor={{ xs: "#fff", sm: "#FAFAFA", md: "#FAFAFA" }}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
      fontFamily="VazirMedium"
    >
      <Box
        xs={4}
        bgcolor="#fff"
        borderRadius={5}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        py={{ xs: 1, sm: 5, md: 4 }}
        px={{ xs: 1, sm: 4, md: 6 }}
        my={5}
      >
        <Logo1 />
        <Typography variant="h1" mt={7} mb={2}>
          رمز عبور جدید
        </Typography>
        <Typography variant="h2" my={2}>
          لطفا رمز جدید خود را وارد کنید
        </Typography>
        <form onSubmit={handleSubmitForm}>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
            <Input placeholder="رمز جدید" type="password" name="password" flex={1} />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
            <Input placeholder="تکرار رمز جدید" type="password" name="confirmPassword" flex={1} />
          </Grid>
          <Button type="submit" variant="l" sx={{ my: 3 }}>
            بعدی
          </Button>
        </form>
      </Box>
      <Footer />
    </Grid>
  );
}

export default NewPassword;

const Style = {
  itemGrid: {
    boxSizing: "border-box",
    margin: "0.2rem 0px",
  },
};
